import {
  ListItem,
  ListItemText,
  ListItemAvatar,
  ListItemSecondaryAction,
  IconButton,
  Tooltip,
  Divider,
  Chip,
 } from "@mui/material";

import {  Star, StarBorder, Chat, GroupWork, Lock  } from "@mui/icons-material";

import moment from "moment";

import { FILTERED_INDICATORS } from "../../../../../constants";
import { ContentContext } from "../../../../../utils/contexts";
import { savePreferences } from "../../../../../actions";
import { getFileIcon } from "../../../../../../../utils";

class File extends React.PureComponent {
	static contextType = ContentContext;

	onClick = () => {
		const { item } = this.props;
		const { onItemSelect } = this.context;
		onItemSelect(item);
	};

	addToFavourites = async () => {
		const { item: { nodeRef } } = this.props;
		const { favouriteDocuments, fetchPreferences } = this.context;
		const newFavourites = { ...favouriteDocuments, [nodeRef]: nodeRef };

		await savePreferences({
			["org.alfresco.share.documents.favourites"]: Object.keys(newFavourites).join(","),
		});

		fetchPreferences();
	};

	removeFromFavourites = async () => {
		const { item: { nodeRef } } = this.props;
		const { favouriteDocuments, fetchPreferences } = this.context;
		const newFavourites = { ...favouriteDocuments };
		delete newFavourites[nodeRef];

		await savePreferences({
			["org.alfresco.share.documents.favourites"]: Object.keys(newFavourites).join(","),
		});

		fetchPreferences();
	};

	render() {
		const {
			item: { properties, name, nodeRef, indicators, originalMimeType, path, version, isLocked, disabled },
			index,
		} = this.props;

		const { selected, hidden, loadingContent, favouriteDocuments, switchValue, searchQuery, currentSite } = this.context;
		const isSelected = Boolean(selected[nodeRef]);
		const isHidden = Boolean(hidden[nodeRef]);
		const isInFavourites = favouriteDocuments[nodeRef];

		const currentDay = moment();
		const modifiedDate = moment(properties["cm:modified"].iso8601);
		const hourDifference = currentDay.diff(modifiedDate, "seconds") / 3600;

		let time = "";
		const isOneDay = hourDifference > 24 && hourDifference < 47;
		if (hourDifference > 24) {
			time = isOneDay
				? window.Alfresco.messages.global["relative.day"]
				: Math.round(hourDifference / 24) + ` ${window.Alfresco.messages.global["date-unit.plural.day"]}`;
		} else {
			time = hourDifference > 1
				? Math.round(hourDifference) + ` ${window.Alfresco.messages.global["date-unit.plural.hour"]}`
				: Math.round(hourDifference * 60) + ` ${window.Alfresco.messages.global["date-unit.plural.minute"]}`;
		}

		const hasWorkflows = indicators.find(ind => ind.id === "active-workflows");
		const fileIcon = getFileIcon("FILE", originalMimeType);

		return (
			<>
				<ListItem
					disableRipple
					disableTouchRipple
					selected={isSelected}
					button
					disabled={isHidden || loadingContent || disabled}
					onClick={(_) => {
						if (isHidden || loadingContent || disabled) return;
						this.onClick();
					}}
					id={`docLibItem${index}`}
					sx={{
						pl: "16px !important",
						pt: 0,
						pb: 0,
						'&.Mui-selected': { backgroundColor: 'rgba(0, 0, 0, 0.08)' },
						opacity: isHidden || loadingContent || disabled ? 0.5 : 1,
						pointerEvents: isHidden || loadingContent || disabled ? 'none' : 'auto',
						cursor: isHidden || loadingContent || disabled ? 'default' : 'pointer',
					}}
				>
					<ListItemAvatar
						sx={{
							fontSize: "22px",
							minWidth: "37px",
							mr: "10px",
							color: "#8e8e8e",
							"& .green": { color: "green" },
							"& .red": { color: "red" },
							"& .blue": { color: "#0e1f3e" },
						}}
					>
						<div style={{ minWidth: "23px", textAlign: "center" }}>
							<i
								className={isSelected ? "fas fa-check-circle blue" : fileIcon.icon}
								style={{ color: isSelected ? "" : fileIcon.color }}
							/>
						</div>
					</ListItemAvatar>
					<ListItemText
						primary={`${name}${window.Edocat?.Config?.showTitle && properties["cm:title"] ? ` (${properties["cm:title"]})` : ""}`}
						secondary={
							(currentSite.nodeRef !== "" && searchQuery !== "" && switchValue) || currentSite.nodeRef === ""
								? path
								: `${window.Alfresco.messages.global[isOneDay ? "prop.cm_modified.title" : "edocat.document-library.edited"]} ${time} ${properties["cm:modifier"].displayName}`
						}
						sx={{
							"& .MuiListItemText-primary, & .MuiListItemText-secondary": {
								maxWidth: "50%",
								fontSize: "13px",
								wordBreak: "break-all",
							},
						}}
					/>
					<ListItemSecondaryAction
						sx={{
							display: "flex",
							flexWrap: "wrap",
							alignItems: "center",
						}}
					>
						{properties["cm:taggable"]?.map(tag => (
							<Chip key={tag.name} label={tag.name} sx={{ m: "0 5px 0 0", p: "5px" }} />
						))}

						{isLocked && properties["cm:lockOwner"] && (
							<Tooltip
								title={`${window.Alfresco.messages.global["edocat.document-library.lock-message"]} ${properties["cm:lockOwner"]}`}
							>
								<Chip
									id={`lockedBtn-docLibItem${index}`}
									label={<Lock fontSize="small" />}
									sx={{
										backgroundColor: "red",
										color: "white",
										fontSize: "10px",
										display: "inline-flex",
										alignItems: "center",
										".MuiChip-label": {
											px: "3px",
										},
									}}
								/>
							</Tooltip>
						)}

						{Boolean(parseInt(properties["fm:commentCount"])) && (
							<Chip
								icon={<Chat fontSize="small" />}
								label={properties["fm:commentCount"]}
								sx={{ m: "0 5px 0 0", p: "5px" }}
							/>
						)}

						{hasWorkflows && (
							<Tooltip title={window.Alfresco.messages.global["edocat.document-library.indicator.workflow"]}>
								<Chip
									label={<GroupWork fontSize="small" />}
									sx={{
										".MuiChip-label": { px: "3px" },
									}}
								/>
							</Tooltip>
						)}

						<Tooltip title={window.Alfresco.messages.global["edocat.all-workflows.filter.document-version"]}>
							<Chip label={version} sx={{ ".MuiChip-label": { px: "3px" } }} />
						</Tooltip>

						<Tooltip
							title={
								isInFavourites
									? window.Alfresco.messages.global["favourite.document.remove.tip"]
									: window.Alfresco.messages.global["favourite.document.add.tip"]
							}
						>
							<IconButton
								onClick={isInFavourites ? this.removeFromFavourites : this.addToFavourites}
								id={`docLibItem${index}FavouriteBtn`}
								disabled={loadingContent}
							>
								{isInFavourites ? (
									<Star fontSize="small" sx={{ color: "#ff9a00" }} />
								) : (
									<StarBorder fontSize="small" />
								)}
							</IconButton>
						</Tooltip>
					</ListItemSecondaryAction>
				</ListItem>
				<Divider sx={{ m: "0 !important" }} />
			</>
		);
	}
}

export default File;